var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDocumentTextEdit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.4 2.383a2.1 2.1 0 0 0-2.1 2.1v15.2c0 1.16.941 2.1 2.1 2.1H8a.7.7 0 1 0 0-1.4H6.4a.7.7 0 0 1-.7-.7v-15.2a.7.7 0 0 1 .7-.7h6.9v3.3a1.7 1.7 0 0 0 1.7 1.7h3.3v.8a.7.7 0 1 0 1.4 0V8.414a1.5 1.5 0 0 0-.439-1.06l-4.53-4.532a1.5 1.5 0 0 0-1.062-.439zm10.91 5-2.61-2.61v2.31a.3.3 0 0 0 .3.3z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8 16.383a.7.7 0 1 0 0 1.4h2a.7.7 0 1 0 0-1.4zM7.3 13.083a.7.7 0 0 1 .7-.7h5a.7.7 0 1 1 0 1.4H8a.7.7 0 0 1-.7-.7"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M17.282 11.97a2.002 2.002 0 1 1 2.832 2.832l-5.436 5.436c-.45.449-1.003.779-1.612.96l-1.865.556a.7.7 0 0 1-.871-.87l.556-1.866a3.8 3.8 0 0 1 .96-1.612zm-.702 2.682-3.743 3.743a2.4 2.4 0 0 0-.61 1.023l-.186.625.625-.186a2.4 2.4 0 0 0 1.022-.61l3.744-3.743zm.99-.99.852.852.702-.702a.602.602 0 1 0-.852-.852z",
  clipRule: "evenodd"
})));
export default SvgDocumentTextEdit;